<template>
  <div
    v-if="modalIsOpened"
    id="teamInfoModal"
    class="fixed inset-0 w-full bg-black/30 z-51"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
      @click.self="closeModal"
    >
      <div
        class="w-[100vw] max-w-[1000px] min-h-[690px] px-[20px] overflow-hidden m-auto"
      >
        <!-- actual modal -->
        <div
          class="h-full mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] pt-[12px] pr-[10px] pb-[20px] pl-[20px]"
          >
            <div class="w-full h-[92px] flex flex-col items-center">
              <TransferIcon class="min-w-[50px] min-h-[50px] text-[#9B237B]" />
              <span class="h-[24px] PC_Body1-SB text-[#1F1D1F]">
                โอนย้ายทรัพยากรระหว่างศูนย์
              </span>
              <div
                class="h-[18px] flex items-center gap-[6px] PC_caption-R text-[#1F1D1F]"
              >
                <span> โอนจาก </span>
                <span> : </span>
                <span> {{ shelterSelf }} </span>
              </div>
            </div>
            <div class="h-[472px] w-full flex flex-col items-start gap-[14px]">
              <div class="w-full">
                <SelectBox
                  :searchable="true"
                  label="โอนไปที่ ศูนย์พักพิง"
                  inputId="shelter_id"
                  valueKey="id"
                  :options="allTransferShelterList"
                  v-model="form.shelter_id"
                  :placeholder="'เลือกศูนย์พักพิง'"
                  @change="
                    (res) => {
                      form.shelter_id = res.id || null;
                    }
                  "
                />
              </div>
              <div class="w-full h-[384px] overflow-scroll">
                <div
                  class="w-full min-h-[600px] grid grid-cols-1 sm:grid-cols-2 items-start gap-[14px] pr-[16px]"
                >
                  <div
                    v-for="(data, index) in transfer"
                    :key="index"
                    class="flex flex-col gap-[10px] p-[14px] rounded-[8px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF]"
                  >
                    <SelectBox
                      :searchable="true"
                      label="ทรัพยากรที่ต้องการโอนย้าย"
                      :inputId="'product' + index"
                      valueKey="product_id"
                      :options="allTransferProductList"
                      v-model="data.product_id"
                      :placeholder="'เลือกทรัพยากร'"
                      @change="
                        (res) => {
                          data.product = res;
                          data.quantity = 0;
                          data.product_id = res.product_id || '';
                        }
                      "
                    />
                    <div
                      class="flex items-center justify-between p-[4px]"
                      :class="data.product_id == '' ? '' : 'bg-[#FBEFF8]'"
                    >
                      <div
                        class="flex items-center gap-[6px] PC_Body2-R"
                        :class="
                          data.product_id == ''
                            ? 'text-[#DFDCDD]'
                            : 'text-[#1F1D1F]'
                        "
                      >
                        <span> จำนวนคงเหลือ </span>
                        <span> : </span>
                        <span>
                          {{ $numberAndComma(data.product?.quantity) || "0" }}
                        </span>
                      </div>
                      <ButtonComponent
                        :label="'โอนทั้งหมด'"
                        :bClass="'btn_shadow--32 !max-w-[92px]'"
                        :disabled="
                          data.product_id == '' ||
                          data.quantity == data?.product?.quantity
                        "
                        @clicked="
                          () => {
                            data.quantity = data.product.quantity;
                          }
                        "
                      />
                    </div>
                    <div class="flex flex-col gap-[12px]">
                      <div
                        class="PC_Body2-R"
                        :class="
                          data.product_id == ''
                            ? 'text-[#DFDCDD]'
                            : 'text-[#1F1D1F]'
                        "
                      >
                        ระบุจำนวนที่ต้องการโอนย้าย
                      </div>
                      <QuantitySelectorComponent
                        :inputClass="'!h-[42px] !min-w-[104px]'"
                        :disabled="data.product_id == ''"
                        :maxValue="data?.product?.quantity"
                        v-model:fieldValue="data.quantity"
                      />
                    </div>
                    <Input
                      label="หมายเหตุ (ถ้ามี)"
                      placeholder="หมายเหตุ (ถ้ามี)"
                      v-model="data.reason"
                    />
                    <ButtonComponent
                      :label="'ลบรายการ'"
                      :bClass="'btn_shadow--cancel !max-w-none !h-[42px]'"
                      @clicked="() => removeResource(index)"
                    />
                  </div>
                  <div
                    @click="addResource"
                    class="GButtonL min-h-[388.4px] flex flex-col items-center justify-center gap-[10px] p-[14px] rounded-[8px] border-[1px] border-solid border-[#B7B2B5] hover:border-[#9B237B] bg-[#FFF] hover:bg-[#FBEFF8] cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="63"
                      height="63"
                      viewBox="0 0 63 63"
                      fill="none"
                    >
                      <path
                        d="M33.8561 15.7747C33.8561 14.472 32.8001 13.416 31.4974 13.416C30.1947 13.416 29.1387 14.472 29.1387 15.7747V29.1407H15.7728C14.4701 29.1407 13.4141 30.1967 13.4141 31.4993C13.4141 32.802 14.4701 33.858 15.7728 33.858H29.1387V47.224C29.1387 48.5267 30.1947 49.5827 31.4974 49.5827C32.8001 49.5827 33.8561 48.5267 33.8561 47.224V33.858H47.222C48.5247 33.858 49.5807 32.802 49.5807 31.4993C49.5807 30.1967 48.5247 29.1407 47.222 29.1407H33.8561V15.7747Z"
                        fill="#9B237B"
                      />
                    </svg>
                    <span class="ButtonL"> เพิ่มรายการโอนย้าย </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'ตกลง'"
                :bClass="'btn_shadow--save'"
                :disabled="!isValid || form.shelter_id === null"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useProductStore } from "@/pinia/product";
import { storeToRefs } from "pinia";

const props = defineProps({
  inShelter: {
    type: Boolean,
    default: false,
  },
});

const productStore = useProductStore();
const { shelterSelf, allTransferShelterList, allTransferProductList } =
  storeToRefs(productStore);

const emit = defineEmits(["status", "open"]);

const input = {
  shelter_id: null,
  transfer: "",
};
const form = ref({ ...input });
const input2 = {
  product: [],
  product_id: "",
  quantity: "0",
  reason: "",
};
const transfer = ref([{ ...input2 }]);
const modalIsOpened = ref(false);

const Options = computed(() => {
  return transfer.value
    .map((item) => item.product)
    .filter((id) => id !== "" && id != null);
});

const isValid = computed(
  () => !transfer.value.some((item) => item.quantity == "0" || !item.product_id)
);

const openModal = async (data, shelterReqData) => {
  form.value.shelter_id = null;
  transfer.value = [
    {
      ...input2,
    },
  ];

  await productStore.getProductShelterSelf();
  await productStore.getAllTransferProductList();

  if (data) {
    transfer.value[0].product = allTransferProductList.value.find(
      (item) => item.product_id == data.id
    );
    transfer.value[0].product_id = data.id;
    transfer.value[0].quantity = "0";
  }

  await productStore.getAllTransferShelterList();
  if (shelterReqData) {
    form.value.shelter_id = shelterReqData.shelter_id;
    form.value.spacial = true;
    form.value.product_request_id = shelterReqData.id;
    transfer.value[0].product = allTransferProductList.value.find(
      (item) => item.product_id == shelterReqData.product_id
    );
    transfer.value[0].product_id = shelterReqData.product_id;
    transfer.value[0].quantity = "0";
    // if (shelterReqData.needed != -1) {
    //   transfer.value[0].quantity = shelterReqData.needed;
    // }
  }

  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const save = async () => {
  const body = {
    ...form.value,
    transfer: transfer.value,
  };
  await productStore
    .createTransferProduct(body)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        emit("open", response.data.data);
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      }
    });
};

const addResource = () => {
  transfer.value.push({ ...input2 });
};

const removeResource = (index) => {
  if (transfer.value[index]) {
    if (index === 0 && transfer.value.length == 1) {
      transfer.value[index] = {
        ...input2,
      };
    } else {
      transfer.value.splice(index, 1);
    }
  }
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
.title {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
.GButtonL {
  &:hover {
    .ButtonL {
      color: #9b237b !important;
    }
  }
}
.ButtonL {
  color: #1f1d1f;
  text-align: center;

  /* Button/L */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
</style>